// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#quiz-settings {
  padding: 1rem;
  overflow: auto;
}


#quiz-settings .back-button {
    color: var(--darkgrey);
    background-color: transparent;
    border-color: var(--shell-bg-color);
    border-radius: 0.2rem;
  }


#quiz-settings .back-button:hover {
    background-color: var(--grey2);
    border-color: var(--shell-bg-color);
  }

#quiz-settings-box {
  display: flex;
  flex-wrap: wrap;
}

#quiz-settings-pdf {
  flex-grow: 1;
  display: flex;
  align-items: end;
}

#quiz-settings-pdf button {
    background-color: var(--white);
    border: 1px solid var(--border-dark-color);
    color: var(--black);
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }

#quiz-settings-pdf button.disabled {
      border-color: var(--grey2);
      color: var(--grey2);
      cursor: not-allowed;
    }

#quiz-settings-pdf button + button,#quiz-settings-pdf button + a,#quiz-settings-pdf a + a {
    margin-left: 0.5rem;
  }

@media (max-width:541px) {}

#quiz-settings-list {
  min-width: 320px;
  width: 50%;
}

#quiz-settings-list .setting {
    margin-bottom: 0.25rem;
  }

#quiz-settings-list .label:first-child::after {
    content: ":";
  }

#quiz-settings-list .label {
    margin-right: 1rem;
    display: inline;
  }

#quiz-settings-list .number-input {
    width: 3rem;
  }

#quiz-settings-list select {
    height: 1.3rem;
  }

#quiz-settings-list .setting-inline {
    display: inline-flex;
  }

#quiz-settings-list .icon {
    display: inline-flex;
    box-sizing: border-box;
    width: 1.4rem;
    height: 1.4rem;
    align-items: center;
    justify-content: center;
    background-color: var(--white);
    border: none;
    cursor: pointer;
  }

#quiz-settings-list .icon:hover {
    border: 1px solid var(--grey3);
    border-radius: 0.2rem;
  }

#quiz-settings-questions {

  width: auto;

}

#quiz-settings-questions .label:first-child::after {
    content: ":";
  }

#quiz-settings-questions .label {
    margin-right: 1rem;
    display: inline;
  }

#quiz-settings-questions .icon {
    display: inline-flex;
    box-sizing: border-box;
    width: 1.4rem;
    height: 1.4rem;
    align-items: center;
    justify-content: center;
    background-color: var(--white);
    border: none;
    cursor: pointer;
  }

#quiz-settings-questions .icon:hover {
    border: 1px solid var(--grey3);
    border-radius: 0.2rem;
  }

.settings-box {
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1rem;
  margin-bottom: 1rem;
}

.quiz-settings-run-empty {
  display: flex;
  justify-content: center;
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1rem;
}

.toolbar-btn-group+.toolbar-btn-group {
  padding-left: 10px;
  margin-left: 10px;
  border-left: 2px var(--grey1) solid;
}

#quizzes-catalog-toolbar {
  display: flex;
}

#quizzes-catalog-toolbar button + button,#quizzes-catalog-toolbar button + a,#quizzes-catalog-toolbar a + a {
    margin-left: 0.5rem;
  }

#quizzes-catalog-toolbar .toolbar-btn-group {
    display: flex;

  }

#quizzes-catalog-toolbar .toolbar-btn-group .toggle-btn + .toggle-btn {
      margin-left: 5px;
    }

#quizzes-catalog-toolbar .toolbar-btn-group .btn-label {
      margin-left: 5px;
    }

#quizzes-catalog-toolbar .toolbar-btn-group .rotate > .icon-toggle-btn-icon{
      animation-name: rotate;
      animation-duration: 3s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuizSettings.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,cAAc;AAahB;;;AAXE;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,mCAAmC;IACnC,qBAAqB;EACvB;;;AAEA;IACE,8BAA8B;IAC9B,mCAAmC;EACrC;;AAGF;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAsBlB;;AApBE;IACE,8BAA8B;IAC9B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;EAOjB;;AALE;MACE,0BAA0B;MAC1B,mBAAmB;MACnB,mBAAmB;IACrB;;AAGF;IAGE,mBAAmB;EACrB;;AAGF,0BAAwB;;AAExB;EACE,gBAAgB;EAChB,UAAU;AA2CZ;;AAzCE;IACE,sBAAsB;EACxB;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,cAAc;EAChB;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;AAGF;;EAEE,WAAW;;AA4Bb;;AA1BE;IACE,YAAY;EACd;;AAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;AAIF;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AA2Bf;;AAzBE;IAGE,mBAAmB;EACrB;;AAEA;IACE,aAAa;;EAiBf;;AAfE;MACE,gBAAgB;IAClB;;AAEA;MACE,gBAAgB;IAClB;;AAEA;MACE,sBAAsB;MACtB,sBAAsB;MACtB,mCAAmC;MACnC,iCAAiC;IACnC;;AAKJ;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import \"../shared.css\";\r\n\r\n\r\n#quiz-settings {\r\n  padding: 1rem;\r\n  overflow: auto;\r\n\r\n  & .back-button {\r\n    color: var(--darkgrey);\r\n    background-color: transparent;\r\n    border-color: var(--shell-bg-color);\r\n    border-radius: 0.2rem;\r\n  }\r\n\r\n  & .back-button:hover {\r\n    background-color: var(--grey2);\r\n    border-color: var(--shell-bg-color);\r\n  }\r\n}\r\n\r\n#quiz-settings-box {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n#quiz-settings-pdf {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  align-items: end;\r\n\r\n  button {\r\n    background-color: var(--white);\r\n    border: 1px solid var(--border-dark-color);\r\n    color: var(--black);\r\n    font-size: 1rem;\r\n    padding: 0.25rem 0.5rem;\r\n    cursor: pointer;\r\n\r\n    &.disabled {\r\n      border-color: var(--grey2);\r\n      color: var(--grey2);\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  button+button,\r\n  button+a,\r\n  a+a {\r\n    margin-left: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (width <=541px) {}\r\n\r\n#quiz-settings-list {\r\n  min-width: 320px;\r\n  width: 50%;\r\n\r\n  & .setting {\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  & .label:first-child::after {\r\n    content: \":\";\r\n  }\r\n\r\n  & .label {\r\n    margin-right: 1rem;\r\n    display: inline;\r\n  }\r\n\r\n  & .number-input {\r\n    width: 3rem;\r\n  }\r\n\r\n  & select {\r\n    height: 1.3rem;\r\n  }\r\n\r\n  & .setting-inline {\r\n    display: inline-flex;\r\n  }\r\n\r\n  & .icon {\r\n    display: inline-flex;\r\n    box-sizing: border-box;\r\n    width: 1.4rem;\r\n    height: 1.4rem;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--white);\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  & .icon:hover {\r\n    border: 1px solid var(--grey3);\r\n    border-radius: 0.2rem;\r\n  }\r\n}\r\n\r\n#quiz-settings-questions {\r\n\r\n  width: auto;\r\n\r\n  .label:first-child::after {\r\n    content: \":\";\r\n  }\r\n\r\n  .label {\r\n    margin-right: 1rem;\r\n    display: inline;\r\n  }\r\n\r\n  .icon {\r\n    display: inline-flex;\r\n    box-sizing: border-box;\r\n    width: 1.4rem;\r\n    height: 1.4rem;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--white);\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .icon:hover {\r\n    border: 1px solid var(--grey3);\r\n    border-radius: 0.2rem;\r\n  }\r\n\r\n}\r\n\r\n.settings-box {\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  padding: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.quiz-settings-run-empty {\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  padding: 1rem;\r\n}\r\n\r\n.toolbar-btn-group+.toolbar-btn-group {\r\n  padding-left: 10px;\r\n  margin-left: 10px;\r\n  border-left: 2px var(--grey1) solid;\r\n}\r\n\r\n#quizzes-catalog-toolbar {\r\n  display: flex;\r\n\r\n  button+button,\r\n  button+a,\r\n  a+a {\r\n    margin-left: 0.5rem;\r\n  }\r\n\r\n  .toolbar-btn-group {\r\n    display: flex;\r\n\r\n    .toggle-btn+.toggle-btn {\r\n      margin-left: 5px;\r\n    }\r\n\r\n    .btn-label {\r\n      margin-left: 5px;\r\n    }\r\n\r\n    .rotate>.icon-toggle-btn-icon{\r\n      animation-name: rotate;\r\n      animation-duration: 3s;\r\n      animation-iteration-count: infinite;\r\n      animation-timing-function: linear;\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
